import React, { memo } from 'react';

import BANNER_CAROUSEL_RIGHT from '../../sections/bannerCarouselRight';
import GRID_CARD from '../../sections/list';
import BANNER_CAROUSEL_CENTER from '../../sections/bannerCarouselCenter';
import BANNER_CAROUSEL_LEFT from '../../sections/bannerCarouselLeft';
import FORM_SUBSCRIBE from '../../sections/subscribeToNewsletter';
import TEXT_TESTIMONIAL from '../../sections/testimonials';
import VIDEO_TESTIMONIAL from '../../sections/videoTestimonials';
import VIDEO from '../../sections/video';
import INFO from '../../sections/info';
import TEXT from '../../sections/text';
import IMAGE_GALLERY from '../../sections/photoGallery';
import FAQ_LISTING from '../../sections/faqListing';
import TEXT_GRID from '../../sections/textGrid';
import COURSE_CAROUSEL from '../../sections/courseCarousel';
import TEAM_CARD from '../../sections/teams';
import CONTACT from '../../sections/contact';
import FORM_ENQUIRY from '../../sections/formEnquiry';
import WEBINAR_LANDING_PAGE from '../../sections/webinarPromotionPage';
import COURSE_LANDING_PAGE from '../../sections/coursePromotionPage';
import FORM_LANDING_PAGE from '../../sections/formPage';
import TILES_SECTION from '../../sections/tilesComponent';
import EMAIL_DRIP_MARKET from '../../sections/EmailDripMarket';
import ABOUT_INSTITUTE from '../../sections/aboutInstitute';
import TIMER_AND_CALL from '../../sections/timerAndCall';

const TYPE_TO_COMPONENT_MAP = {
  BANNER_CAROUSEL_RIGHT,
  GRID_CARD,
  BANNER_CAROUSEL_CENTER,
  BANNER_CAROUSEL_LEFT,
  FORM_SUBSCRIBE,
  TEXT_TESTIMONIAL,
  VIDEO_TESTIMONIAL,
  VIDEO,
  INFO,
  TEXT,
  IMAGE_GALLERY,
  FAQ_LISTING,
  TEXT_GRID,
  COURSE_CAROUSEL,
  TEAM_CARD,
  CONTACT,
  FORM_ENQUIRY,
  WEBINAR_LANDING_PAGE,
  COURSE_LANDING_PAGE,
  FORM_LANDING_PAGE,
  TILES_SECTION,
  EMAIL_DRIP_MARKET,
  ABOUT_INSTITUTE,
  TIMER_AND_CALL
};

const getCompToRender = (type) => TYPE_TO_COMPONENT_MAP[type] || (() => null);

const MemoisedSection = memo(
  ({ sectionData, extraProps, isCustomWebsite, sectionIndex }) => {
    console.log('extraProps in section data', extraProps);
    const SectionComp = getCompToRender(sectionData.type);

    return (
      <SectionComp
        sectionData={sectionData}
        extraProps={extraProps}
        isCustomWebsite={isCustomWebsite}
        sectionIndex={sectionIndex}
      />
    );
  }
);

export default function SectionRenderer({
  sectionData,
  extraProps,
  isCustomWebsite,
  sectionIndex
}) {
  return (
    <MemoisedSection
      sectionData={sectionData}
      extraProps={extraProps}
      isCustomWebsite={isCustomWebsite}
      sectionIndex={sectionIndex}
    />
  );
}
